import { IconLink } from '@tabler/icons-react'
import React, { useRef, useState } from 'react'
import AddLinkToBlock from '../AddLinkToBlock';
import { uploadImage } from '../../../../api/api.global';
import { toast } from 'sonner';
import { ensureHttpPrefix } from '../../../../utils/url.utils';

const LinkBlock = ({ blockData, createBlockFunction, cancelFunction }) => {

    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(file);
        }
    }

    const onCancel = () => {
        if (cancelFunction) {
            cancelFunction();
        }
    }

    const create = async () => {
        if (document.getElementById('destinationUrl').value?.trim() && document.getElementById('title').value?.trim()) {
            let data = {
                blockType: 1,
                images: [{
                    title: document.getElementById('title').value?.trim(),
                    description: document.getElementById('description').value?.trim(),
                    destinationUrl: ensureHttpPrefix(document.getElementById('destinationUrl').value?.trim()),
                    image: file ? await uploadImage(file, 'advy-pages') : '',
                    shortLinkDomain: document.getElementById('select-short-link-domain')?.value?.trim(),
                }],
            }
            createBlockFunction(data);
            onCancel();
        } else {
            toast.error("Title and Url is Required");
        }
    };

    return (
        <div className='p-3 rounded-lg border-2 border-primary'>
            <p className="flex items-center text-sm font-semibold gap-2"> <IconLink size={18} /> Attriva Link </p>
            <div className="flex gap-3">
                <div className='w-40'>
                    <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                    <button onClick={() => imageUploadInputRef.current.click()}>
                        <img src={file ? URL.createObjectURL(file) : blockData?.image ? URL.createObjectURL(blockData?.image) : (process.env.PUBLIC_URL + "/images/image-upload.png")} id='link-image-preview' className='cursor-pointer  rounded-lg object-cover' alt="" />
                    </button>
                    <p className="text-xs text-gray-400">*Maximum size: 5MB, <br /> preferred ratio is 1:1</p>
                </div>
                <div className='w-full'>
                    <p className="text-md font-semibold mb-1.5">Title & Description</p>
                    <input type="text" className="form-control mb-2 w-full" placeholder="Enter Title" id='title' defaultValue={blockData?.title} maxLength={255} />
                    <input type="text" className="form-control w-full" placeholder="Enter Description (Optional) (Max 140 Words)" id='description' defaultValue={blockData?.description} maxLength={140} />
                </div>
            </div>

            <AddLinkToBlock />

            <div className="flex justify-end items-center mt-3 gap-3">
                <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => onCancel()}>Cancel</button>
                <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => create()}>Create</button>
            </div>

        </div>
    )
}

export default LinkBlock